import { useCreateUserMapping } from 'api/MappingsAPI';
import { useCustomEventsQueryContext } from 'modules/customEvents/contexts';
import { useUserMappingsContext } from 'modules/dataDictionary/contexts';
import { useCreateFieldModal } from 'modules/dataDictionary/hooks';
import { createFieldPayload } from 'modules/dataDictionary/utils';
import { useFormContext } from 'react-hook-form';
import { MappingFieldValues } from '../../types';
import { CreateFieldModal } from './CreateFieldModal';

export const CreateUserFieldModal = ({ parentName }: { parentName: string }) => {
  const { setError } = useFormContext();
  const { refetchUserMappings: refetch, userMappings } = useUserMappingsContext();
  const { project } = useCustomEventsQueryContext();
  const { handleSubmit, hasError, isDisabled, isSubmitting, onClose, onError, onSuccess } =
    useCreateFieldModal({ refetch });

  const { mutate } = useCreateUserMapping({ onSuccess, onError });

  const onSubmit = (data: MappingFieldValues) => {
    const payload = createFieldPayload(data, project?.id, parentName);
    const existingField = userMappings.find((field) => field.fieldName === payload?.fieldName);

    if (existingField) {
      setError('fieldName', { message: 'Duplicate name' });
      return null;
    }

    if (payload && !existingField) {
      mutate(payload);
    }
  };

  return (
    <CreateFieldModal
      handleSubmit={handleSubmit(onSubmit)}
      hasError={hasError}
      isDisabled={isDisabled}
      isSubmitting={isSubmitting}
      onClose={onClose}
      parentName={parentName}
    />
  );
};
